import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import PageHeader from "../Components/Pageheader";
import {
  blog1,
  blog2,
  blog3,
  blog4,
  blog5,
  blog6,
  blog7,
  blog8,
  blog9,
  calicon,
} from "../Constant/Index";
import "../assets/Css/blog.css";
import { Link } from "react-router-dom";

function Blogs() {
  const blogsdata = [
    {
      img: blog1,
      date: "20 Feb 2024",
      head: "Elevate Your Spiritual Practice With Powerful Hand",
      para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    },
    {
      img: blog2,
      date: "20 Feb 2024",
      head: "Elevate Your Spiritual Practice With Powerful Hand",
      para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    },
    {
      img: blog3,
      date: "20 Feb 2024",
      head: "Elevate Your Spiritual Practice With Powerful Hand",
      para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    },
    {
      img: blog4,
      date: "20 Feb 2024",
      head: "Elevate Your Spiritual Practice With Powerful Hand",
      para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    },
    {
      img: blog5,
      date: "20 Feb 2024",
      head: "Elevate Your Spiritual Practice With Powerful Hand",
      para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    },
    {
      img: blog6,
      date: "20 Feb 2024",
      head: "Elevate Your Spiritual Practice With Powerful Hand",
      para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    },
    {
      img: blog7,
      date: "20 Feb 2024",
      head: "Elevate Your Spiritual Practice With Powerful Hand",
      para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    },
    {
      img: blog8,
      date: "20 Feb 2024",
      head: "Elevate Your Spiritual Practice With Powerful Hand",
      para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    },
    {
      img: blog9,
      date: "20 Feb 2024",
      head: "Elevate Your Spiritual Practice With Powerful Hand",
      para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    },
  ];
  return (
    <>
      <Header />
      <PageHeader pagename="Blogs" />
      <section className="blogs-sec">
        <div className="container">
          <div className="row">
            {blogsdata?.map((data, blogindex) => {
              return (
                <>
                  <div className="col-md-4" key={blogindex}>
                    <div className="all-blog-stuff">
                      <div className="blog-img">
                        <img
                          src={data?.img}
                          className="img-fluid"
                          alt="blog-images"
                        />
                      </div>
                      <div className="blog-text">
                        <span className="secondary-color">
                          <img src={calicon} className="img-fluid" />{" "}
                          {data?.date}
                        </span>
                        <h3 className="primary-color" style={{
                          textDecoration: "underline"
                        }}>{data?.head}</h3>
                        <p className="extra-color-6">{data?.para}</p>
                        <div className="blog-btn">
                          <Link to="/blog-detail">
                            {" "}
                            <button
                              className="btn-all"
                              style={{ width: "40%" }}
                            >
                              View Detail
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>

          <div className="pagination">
            <nav aria-label="Page navigation example">
              <ul className="pagination justify-content-center">
                <li className="page-item ">
                  <a className="page-link primary-color extra-color-7" href="#">
                    1
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link primary-color extra-color-7" href="#">
                    2
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link primary-color extra-color-7" href="#">
                    3
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link primary-color extra-color-7" href="#">
                    4
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link primary-color extra-color-7" href="#">
                    5
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link primary-color extra-color-7" href="#">
                    6
                  </a>
                </li>
                <li className="page-item">...</li>
                <li className="page-item">
                  <a className="page-link primary-color extra-color-7" href="#">
                    12
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Blogs;
